import { AddCircle, Edit, Home, LockPerson, People } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import debounce from "lodash/debounce";
import React, { useCallback, useEffect, useState } from "react";
import { Badge, Button } from "react-bootstrap";
import { assets } from "../../../assets";
import ReusableTable from "../../../components/custom/data_table/ReusableTable";
import IconBreadcrumbs from "../../../components/custom/IconBreadcrumbs";
import Loader from "../../../components/custom/Loader";
import { useGetAdminUserQuery } from "../../../redux/api/userApiSlice";
import { convertToBanglaNumerals } from "../../../utils/convertToBanglaNumerals";
import AddUser from "./AddUser";
import ShowUser from "./ShowUser";

const User = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [status] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [user, setUser] = useState(null);

  const {
    data: adminUser,
    isLoading,
    refetch,
  } = useGetAdminUserQuery({
    currentPage,
    searchValue,
    status,
  });

  const totalData = adminUser?.meta?.total;
  const lastPage = adminUser?.meta?.last_page;

  const debouncedSearch = useCallback(
    debounce((value) => {
      setCurrentPage(1);
      setSearchValue(value);
      refetch();
    }, 400),
    []
  );

  useEffect(() => {
    // Cleanup function to cancel the debounce when the component unmounts or debouncedSearch changes
    return () => {
      debouncedSearch?.cancel();
    };
  }, [debouncedSearch]);

  const handleSearchChange = (value) => {
    setSearchText(value);
    debouncedSearch(value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    refetch();
  };

  const columns = [
    { label: "ক্রমিক নং", name: "si" },
    {
      label: "ছবি",
      name: "image",
      options: {
        customBodyRender: (value) => {
          return (
            <img
              alt=""
              src={value}
              style={{
                height: "50px",
                width: "50px",
                objectFit: "cover",
                borderRadius: "10px",
                border: "1px solid #ccc",
              }}
            />
          );
        },
      },
    },
    { label: "নাম", name: "name" },
    {
      label: "পদবী",
      name: "role",
      options: {
        customBodyRender: (value) => {
          return (
            <span
              className="m-1 py-1 px-3 border rounded"
              style={{ fontSize: "14px" }}
            >
              {value}
            </span>
          );
        },
      },
    },

    { label: "ব্যবহারকারী নাম", name: "username" },
    { label: "ই-মেইল", name: "email" },
    { label: "মোবাইল নং", name: "phone" },
    {
      label: "স্ট্যাটাস",
      name: "status",
      options: {
        customBodyRender: (value) => {
          let status, color;

          switch (value) {
            case 1:
              status = "active";
              color = "success";
              break;
            case 2:
              status = "In-Active";
              color = "danger";
              break;
            case 3:
              status = "Pending";
              color = "warning";
              break;
            default:
              status = null;
              color = null;
          }

          return <Badge bg={color}>{status}</Badge>;
        },
      },
    },
    {
      label: "ক্রিয়াকলাপ",
      name: "action",
      options: {
        customBodyRender: (value, tableMeta) => (
          <Box display={"flex"} gap={1}>
            <Tooltip title="সম্পাদন" placement="top" arrow>
              <Badge
                bg="warning"
                className="p-2"
                onClick={() => {
                  setUser(value);
                  setShowModal(true);
                }}
                style={{ cursor: "pointer" }}
              >
                <Edit fontSize="8px" />
              </Badge>
            </Tooltip>
            <Tooltip title="পারমিশন" placement="top" arrow>
              <Badge
                bg="primary"
                className="p-2"
                onClick={() => {
                  setUser(tableMeta?.rowData);
                  setShowUserModal(true);
                }}
                style={{ cursor: "pointer" }}
              >
                <LockPerson fontSize="8px" />
              </Badge>
            </Tooltip>
          </Box>
        ),
      },
    },
  ];

  const data = adminUser?.data.map((item, i) => ({
    si: convertToBanglaNumerals((currentPage - 1) * 10 + i + 1),
    id: item.id,
    action: {
      id: item.id,
      name: item.name,
      email: item.email,
      cell: item.cell,
      role_id: Number(item.role?.id),
      username: item.username,
      status: Number(item.status),
      sl: Number(item.sl),
    },
    name: item.name,
    image: item.image ? item.image : assets.avatar,
    email: item.email,
    username: item.username,
    phone: item.cell,
    role: item.role?.name,
    status: Number(item.status),
    signature: item.signature,
  }));

  const breadcrumbsData = [
    { icon: Home, title: "হোম", url: "/" },
    {
      icon: People,
      title: "ব্যবহারকারীর তালিকাঃ",
      url: "/admin/users",
      active: true,
    },
  ];

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        py={1}
        mb={1}
      >
        <IconBreadcrumbs breadcrumbs={breadcrumbsData} />
        <Button
          variant="outline-secondary"
          onClick={() => {
            setUser(null);
            setShowModal(true);
          }}
        >
          <AddCircle /> ব্যবহারকারী যোগ করুন
        </Button>
      </Box>
      <div className="slideUp dashboard-layout p-4">
        {/* // bootstrap button group active ==1 inactive ==2 pending ==3 */}
        {/* <div className="pb-3">
          <Nav variant="tabs" defaultActiveKey={status}>
            <Nav.Item onClick={() => setStatus(1)}>
              <Nav.Link eventKey={"1"}>Active</Nav.Link>
            </Nav.Item>
            <Nav.Item onClick={() => setStatus(2)}>
              <Nav.Link eventKey="2">Inactive</Nav.Link>
            </Nav.Item>
          </Nav>
        </div> */}
        <ReusableTable
          title={"ব্যবহারকারীর তালিকাঃ"}
          columns={columns}
          data={data}
          isLoading={isLoading}
          currentPage={currentPage}
          lastPage={lastPage}
          totalData={totalData}
          onSearchChange={handleSearchChange}
          searchText={searchText}
          onPageChange={handlePageChange}
        />
      </div>
      {showModal && (
        <AddUser
          user={user}
          show={showModal}
          refetch={refetch}
          onHide={() => {
            setShowModal(false);
            setUser(null);
          }}
        />
      )}
      {showUserModal && (
        <ShowUser
          user={user}
          show={showUserModal}
          onHide={() => {
            setShowUserModal(false);
            setUser(null);
          }}
        />
      )}
    </div>
  );
};

export default User;
